module.exports = __webpack_public_path__ + "static/media/oms.faf0b062.png";